import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { ModalComponent } from "@shared/components/modal/modal.component";
import { ToastComponent } from "@shared/components/toast/toast.component";

@Component({
    selector: "app-guest-layout",
    standalone: true,
    imports: [RouterOutlet, ToastComponent, ModalComponent],
    templateUrl: "./guest-layout.component.html",
    styleUrl: "./guest-layout.component.scss",
})
export class GuestLayoutComponent {}
